import { MESSAGES_COUNT_SET, NOTIFICATIONS_COUNT_SET } from '../action-types/messages.action-types';

export type MessagesReducer = {
  messages: number;
  notifications: number;
};

const initialState: MessagesReducer = {
  messages: 0,
  notifications: 0,
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGES_COUNT_SET: {
      return {
        ...state,
        messages: action.data,
      };
    }
    case NOTIFICATIONS_COUNT_SET: {
      return {
        ...state,
        notifications: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default messagesReducer;
